// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__k-5pN","label":"Labeled_label__pg9Uc","divider":"Labeled_divider__2SAKG"};